import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AbstractApiGuardService } from './abstract.api-guard.service';

export interface UserDirectoryRow {
  id: string;
  email: string;
  fullName: string | null;
  privilegeLevels: { uuid: string; name: string }[];
  isAdmin: boolean;
  validatedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UsersPagedResponse {
  items: UserDirectoryRow[];
  total: number;
  page: number;
  pageSize: number;
}

@Injectable({
  providedIn: 'root',
})
export class UsersApiService extends AbstractApiGuardService {
  private readonly baseUrl = `${environment.apiVersionString}/users`;

  listPaged(params: {
    page?: number;
    pageSize?: number;
    q?: string;
    adminsOnly?: boolean;
  } = {}): Observable<UsersPagedResponse> {
    const query = new URLSearchParams();
    if (params.page) query.set('page', String(params.page));
    if (params.pageSize) query.set('pageSize', String(params.pageSize));
    if (params.q?.trim()) query.set('q', params.q.trim());
    if (params.adminsOnly) query.set('adminsOnly', 'true');
    const qs = query.toString();
    return this.get<UsersPagedResponse>(`${this.baseUrl}/paged${qs ? `?${qs}` : ''}`);
  }

  deleteUser(userId: string): Observable<{ message: string }> {
    return this.delete<{ message: string }>(`${this.baseUrl}/${userId}`);
  }
}
